<template>
  <header class="sticky top-0 z-50 bg-white">
    <nav class="flex items-center justify-between p-4 lg:px-8 max-w-8xl mx-auto" aria-label="Global">
      <div class="flex items-center">
        <a href="/" class="-m-1.5 p-1.5 flex items-center">
          <img class="h-8 w-auto rounded-md" src="/favicon.webp" alt="logo" loading="lazy" />
          <h1 class="ml-2 text-xl font-bold text-indigo-900">Bulba</h1>
        </a>
      </div>
      <div class="flex lg:hidden">
        <button
          type="button"
          class="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700"
          @click="mobileMenuOpen = true"
        >
          <Bars3Icon class="h-6 w-6" aria-hidden="true" />
        </button>
      </div>
      <!-- <div class="hidden lg:flex lg:gap-x-8">
        <a
          v-for="item in navigation"
          :key="item.name"
          :href="item.href"
          :target="item.target ? item.target : '_self'"
          class="text-sm font-semibold leading-6 text-gray-700 hover:text-indigo-600 transition-colors"
          >{{ item.name }}</a
        >
      </div> -->
      <div class="hidden lg:flex lg:items-center lg:gap-x-4">
        <template v-if="!mainStore.currentBrand">
          <RouterLink :to="{ name: 'login' }" class="text-sm font-semibold leading-6 text-gray-700 hover:text-indigo-600 transition-colors"
            >Log in</RouterLink
          >
          <RouterLink
            to="/business/signup"
            class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 transition-colors"
          >Get started
          </RouterLink>
        </template>
        <a
          v-else
          href="/business"
          class="rounded-md bg-indigo-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 transition-colors"
        >
          Go to dashboard
        </a>
      </div>
    </nav>
    <Dialog as="div" class="lg:hidden" @close="mobileMenuOpen = false" :open="mobileMenuOpen">
      <div class="fixed inset-0 z-50" />
      <DialogPanel
        class="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-6 py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10"
      >
        <div class="flex items-center justify-between">
          <a href="#" class="-m-1.5 p-1.5">
            <img class="h-8 w-auto" src="/favicon.webp" alt="logo" loading="lazy" />
          </a>
          <button
            type="button"
            class="-m-2.5 rounded-md p-2.5 text-gray-700"
            @click="mobileMenuOpen = false"
          >
            <XMarkIcon class="h-6 w-6" aria-hidden="true" />
          </button>
        </div>
        <div class="mt-6 flow-root">
          <div class="-my-6 divide-y divide-gray-500/10">
            <div class="space-y-2 py-6">
              <a
                v-for="item in navigation"
                @click="mobileMenuOpen = false"
                :key="item.name"
                :href="item.href"
                :target="item.target ? item.target : '_self'"
                class="-mx-3 block rounded-lg py-2 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
                >{{ item.name }}
              </a>
            </div>
            <div class="py-6">
              <RouterLink
                v-if="!mainStore.currentBrand"
                to="/login"
                class="-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
              >
                Log in
              </RouterLink>
              <a
                href="/business"
                class="-mx-3 block rounded-lg py-2.5 px-3 text-base font-semibold leading-7 text-gray-900 hover:bg-gray-50"
              >
                Go to dashboard
              </a>
            </div>
          </div>
        </div>
      </DialogPanel>
    </Dialog>
  </header>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Dialog, DialogPanel } from '@headlessui/vue'
import { Bars3Icon, XMarkIcon } from '@heroicons/vue/24/outline'
import { useMainStore } from '@/stores/main'

const mainStore = useMainStore()

const navigation = [
  { name: 'Pricing', href: '/#pricing' },
  { name: 'I am an influencer', href: 'https://apps.apple.com/gb/app/bulba-creators-x-venues/id6448395816?platform=iphone', target: "_blank" },
]

const mobileMenuOpen = ref(false)
</script>